<template>
  <component
    :is="$options.gameContainers[$attrs.gameName]"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'GameContainer',
  gameContainers: {
    multiProjectStandard: () => import('./multi-project/MultiProjectStandardContainer'),
    multiProjectCcpm: () => import('./multi-project/MultiProjectCcpmContainer'),
    multiTaskParallel: () => import('./multi-task/MultiTaskParallelContainer'),
    multiTaskSequential: () => import('./multi-task/MultiTaskSequentialContainer'),
    networkDiagramWithoutInstructions: () => import('./network-diagram/NetworkDiagramWithoutInstructionsContainer'),
    networkDiagramWithInstructions: () => import('./network-diagram/NetworkDiagramWithInstructionsContainer'),
    onTime: () => import('./on-time/OnTimeContainer'),
    criticalChain: () => import('./critical-chain/CriticalChainContainer'),
  },
}
</script>
